var details = {
    text1:"THE POINTS YOU WILL EARN FOR EVERY BOOKING ARE:",
    table1: "Marival® Emotions Resort & Suites:",
    pointsTable1: "1 Point - Suites",
    table2: "Marival® Distinct Luxury Residences:",
    pointsTable2: "1 Point - 1-Bedroom",
    table3: "Marival® Distinct Luxury Residences:",
    pointsTable3: "2 Points - 2-Bedroom and up",
    table4: "Marival® Armony Luxury Resort & Suites:",
    pointsTable4: "2 Points - any room",
    table5: "Marival® Armony Luxury Resort & Suites:",
    pointsTable5: "2 Points - Suites",

    table7: "Marival® Emotions Resort Category:",
    pointsTable7: "1 Point",
    table8: "Marival® Emotions Resort Category:",
    pointsTable8: "2 Points - 7 Nights or more",

    text2: "Bonus Points:",
    text3: "Family Emotion:",
    text4: "1 Point earned per room.",
    text5: "We know all families want special treats. That's why, with the Family Emotion program of Marival® Resorts, you get to customize the perfect family vacation- from beginning to end.",
    text6: "*Double points do not apply for Bonus Points.",
    text7: "",
    note: "Note:",
    noteText: "Points earned on all direct bookings and also for those made through your favorite tour operator.",
    noteText1: "A minimum 3-night's stay is required to start earning rewards. The points earned apply for stays of up to 6 nights. For stays of 10 nights or more you earn double points. This applies to all direct bookings and also for those made through your favorite tour operator.",
    
    text8: "What Kind Of Award Can I Earn?",
    text9: "Hotel stays apply for 1-Bedroom suite category in double occupancy at Marival® Emotions Resort & Suites, 1-Bedroom category in double occupancy at Marival® Distinct Luxury Residences, and Armony Room category in double occupancy at Marival® Armony Luxury Resort & Suites.",
    text10: "Track & redeem",
    text11: "- (Marival Rewards Program subject to changes without prior notice).",
    text12: "- Please allow 3-5 weeks for awards to be delivered after client's departure",
    text13: "- subject to availability",
    text14: "Other legal language:",
    text15: "example text",
    note1:"You cannot use more than two rooms on the same date.",
    note2:"(Blackout dates apply such as for Easter, Summer, Thanksgiving, Holy Week, & Mexican Holidays)",
    notApplyGroups:"Does not apply to groups.",

    noteText2:"A minimum 3-night's stay is required to start earning rewards. The points earned apply for stays of up to  10 nights. For stays of  11 nights or more you earn double points. This applies to all direct bookings and also for those made through your favorite tour operator",
    noteText3: "Points earned on all direct bookings and also for those made through your favorite tour operator.",
 
    table100:"Marival® Emotions Resort & Suite",
    table101:"1 Point",
    table102:"Resort Room",
    table103:"Marival® Emotions Resort & Suite",
    table104:"2 Points",
    table105:"Suite",
    table106:"Marival® Armony Luxury Resort & Suite",
    table107:"1 Point",
    table108:"Lush Room",
    table109:"Marival® Armony Luxury Resort & Suite",
    table110:"2 Points",
    table111:"Bahia Room, Armony, Sierra & Allure",
    table112:"Marival® Armony Luxury Resort and Suite",
    table113:"3 Points",
    table114:"Suite",
    table115:"Marival® Distinct Luxury Residences",
    table116:"1 Point",
    table117:"Standard Residence",
    table118:"Marival® Distinct Luxury Residences",
    table119:"2 Points",
    table120:"Luxury Ocean View Residence",
    table121:"Marival® Distinct Luxury Residences",
    table122:"3 Points",
    table123:"Demi Pool & Penthouse Residences, and Villas",
    tablefour:"4 Points",
    tablesix:"6 Points",
    roomcategory:"Room Category",
    nights: "nights",
    noteText10:"A minimum stay of 3 nights is required to generate Points. Points apply for stays of up to 6 nights; stays of 7 nights or more, generate double Points. Applies for reservations entered through any channel and through your favorite tour operator.",

   // text20:"For details on the applicable room categories for 2 night stays please click here:",
   // text21:"For details on the applicable room categories for 2 night stays please click here:",
    text20:"",
    text21:"",
    text22:"To Learn More About <b>Tango</b> and the Retail Partners offered <br/><a href='https://www.tangocard.com/reward-catalog?rewardcountries=US&rewardcategory=gift+card' target='_new'>– CLICK HERE TO LEARN MORE ABOUT TANGO RETAIL PARTNERS</a> "

    

}
module.exports = details
